import { env } from "@/lib/env";

// In-memory only. The parent owns the staff session, banner and stop action.
export const isSupportView =
  window.parent !== window &&
  (window.name === "sked-support-link" ||
    new URLSearchParams(window.location.search).has("impersonation"));
if (isSupportView) {
  localStorage.clear();
  sessionStorage.clear();
}
let cached: { token: string; expiresAt: number } | undefined;
let pending: Promise<string> | undefined;

export function supportToken(): Promise<string> {
  if (!isSupportView) return Promise.reject(new Error("Not a support view"));
  if (cached && cached.expiresAt > Date.now() + 10_000)
    return Promise.resolve(cached.token);
  if (pending) return pending;
  pending = new Promise<string>((resolve, reject) => {
    if (!env.schedugramServerBackendUrl) {
      reject(new Error("Support origin is not configured"));
      return;
    }
    const origin = new URL(env.schedugramServerBackendUrl).origin;
    const requestId = crypto.randomUUID();
    const listener = (event: MessageEvent) => {
      if (
        event.origin !== origin ||
        event.source !== window.parent ||
        event.data?.type !== "sked-support-token-result" ||
        event.data.requestId !== requestId
      )
        return;
      window.removeEventListener("message", listener);
      window.clearTimeout(timeout);
      if (
        typeof event.data.accessToken !== "string" ||
        !Number.isFinite(event.data.expiresIn)
      ) {
        reject(new Error("Invalid support response"));
        return;
      }
      cached = {
        token: event.data.accessToken,
        expiresAt: Date.now() + event.data.expiresIn * 1000,
      };
      resolve(cached.token);
    };
    const timeout = window.setTimeout(() => {
      window.removeEventListener("message", listener);
      reject(new Error("Support session unavailable"));
    }, 10000);
    window.addEventListener("message", listener);
    window.parent.postMessage(
      { type: "sked-support-token", requestId },
      origin
    );
  }).finally(() => {
    pending = undefined;
  });
  return pending;
}
